<template>
  <tr
    class="row-table font-normal text-base h-24 border-2 border-zt-dark-200 rounded relative"
  >
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        <zt-avatar
          :text="item.usuario_nombre"
          color="secondary-100"
          class="mr-4"
        />
        {{ item.usuario_nombre }}
      </div>
    </td>
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        {{ item.sm_alias }}
      </div>
    </td>
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        {{ item.created }}
      </div>
    </td>
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        {{ item.started }}
      </div>
    </td>
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        {{ item.finished }}
      </div>
    </td>
    <td>
      <div class="w-full h-full flex justify-start items-center px-8">
        <zt-badge square :color="itemStatus.color">
          <em class="text-base not-italic text-center">{{
            itemStatus.text
          }}</em>
        </zt-badge>
      </div>
    </td>
    <td>
      <div v-if="item.sm_process !== 'vp_absences_historic_sync'" class="w-full h-full flex justify-start items-center px-10">
        <zt-button
          v-if="item.output_status === 'processed'"
          data-vs-button="btn-redirect-massive-upload"
          @click="redirectToMassiveUpload"
        >
          {{ $t('message.processManager.table.continue') }}
        </zt-button>

        <button
          v-else
          @click="openModal(item)"
          data-vs-button="open-modal-detail"
        >
          <zt-icon name="eye" class="text-zt-lg" />
        </button>
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: 'RowTable',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    openDetail: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false
    }
  },
  computed: {
    itemStatus() {
      const result = {
        text: this.$t('message.processManager.table.inProgress'),
        color: '03a9f4'
      }
      switch (this.item.output_status) {
        case 'warning':
          result.text = this.$t('message.processManager.table.withObservation')
          result.color = 'D39011'
          break
        case 'error':
        case 'Error':
          result.text = this.$t('message.processManager.table.withError')
          result.color = 'F16B6C'
          break
        case 'success':
          result.text = this.$t('message.processManager.table.withSuccess')
          result.color = '54CAA6'
          break
        case 'processed':
          result.text = this.$t('message.processManager.table.processed')
          result.color = '898DFFFF'
          break
        case 'deleted':
          result.color = '969696FF'
          result.text = this.$t('message.processManager.table.canceled')
          break
        case 'split_and_crop':
          result.text = this.$t('message.processManager.table.canceled')
          result.color = 'D39011'
          break
      }
      return result
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    redirectToMassiveUpload() {
      location.href = '/s/documents/publish/massive'
    },
    openModal(item) {
      this.openDetail({
        ...item,
        ...(item.output_status === 'error' && item.output_format === 'json'
          ? {
              output: this.errorHandler(item.output)
            }
          : {})
      })
    },
    errorHandler(value) {
      const output = JSON.parse(value).error
      const errorMessage = {
        CUT_PARAMETERS_NOT_DEFINED: this.$t(
          'message.processManager.errors.CUT_PARAMETERS_NOT_DEFINED'
        ),
        CUT_AND_ROTATE_PARAMETERS_NOT_DEFINED: this.$t(
          'message.processManager.errors.CUT_AND_ROTATE_PARAMETERS_NOT_DEFINED'
        ),
        ROTATE_PARAMETER_NOT_DEFINED: this.$t(
          'message.processManager.errors.ROTATE_PARAMETER_NOT_DEFINED'
        ),
        DOCUMENTS_DIRECTORY_INVALID: this.$t(
          'message.processManager.errors.DOCUMENTS_DIRECTORY_INVALID'
        ),
        CREATE_CERTIFICATE_DIRECTORY_ERROR: this.$t(
          'message.processManager.errors.CREATE_CERTIFICATE_DIRECTORY_ERROR'
        ),
        CREATE_OUTPUT_DIRECTORY_ERROR: this.$t(
          'message.processManager.errors.CREATE_OUTPUT_DIRECTORY_ERROR'
        ),
        CREATE_ZIP_OUTPUT_DIRECTORY_ERROR: this.$t(
          'message.processManager.errors.CREATE_ZIP_OUTPUT_DIRECTORY_ERROR'
        ),
        CREATE_ZIP_FILE_ERROR: this.$t(
          'message.processManager.errors.CREATE_ZIP_FILE_ERROR'
        ),
        CERTIFICATE_NOT_FOUND: this.$t(
          'message.processManager.errors.CERTIFICATE_NOT_FOUND'
        ),
        CREATE_CERTIFICATE_FILE_ERROR: this.$t(
          'message.processManager.errors.CREATE_CERTIFICATE_FILE_ERROR'
        ),
        CREATE_PRIVATE_KEY_FILE_ERROR: this.$t(
          'message.processManager.errors.CREATE_PRIVATE_KEY_FILE_ERROR'
        ),
        SIGNATURE_PROCESS_ENDS_WITH_ERRORS: this.$t(
          'message.processManager.errors.SIGNATURE_PROCESS_ENDS_WITH_ERRORS'
        ),
        SIGNATURE_POSITION_INVALID: this.$t(
          'message.processManager.errors.SIGNATURE_POSITION_INVALID'
        ),
        INVALID_PASSPHRASE_FOR_SUPPLIED_PRIVATE_KEY: this.$t(
          'message.processManager.errors.INVALID_PASSPHRASE_FOR_SUPPLIED_PRIVATE_KEY'
        ),
        CERTIFICATE_IS_DISABLED: this.$t(
          'message.processManager.errors.CERTIFICATE_IS_DISABLED'
        )
      }
      return errorMessage[output]
        ? errorMessage[output]
        : 'Se ha detectado un error durante el proceso. API error:' +
            ' ' +
            output
    }
  }
}
</script>

<style scoped lang="scss">
.row-table button {
  opacity: 0;
}
.row-table:hover {
  box-shadow: inset 0 0 0 2px #4f4f4f;
  border-radius: 0 !important;
  button {
    opacity: 1;
  }
}
::v-deep .zt-badge {
  padding: 0.5rem 1rem !important;
  min-width: 138px;
  justify-content: center;
  max-width: 138px;
  white-space: pre-wrap;
}
</style>
